import { Component } from '@angular/core';
import { OnboardingQueries } from '../../../../../../core/store/onboarding/onboarding.queries';
import { StepperQueries } from '../../../../../../core/store/stepper/stepper.queries';
import { HttpService } from '../../../../../../core/services/http/http.service';
import { EntityQueries } from '../../../../../../core/store/entity/entity.queries';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigQueries } from '../../../../../../core/store/config/config.queries';
import { BaseDueDiligenceComponent } from '../../base-due-diligence.component';

@Component({
	selector: 'bcb-regulatory-info',
	templateUrl: './regulatory-info.component.html',
	styleUrls: ['./regulatory-info.component.scss'],
})
export class RegulatoryInfoComponent extends BaseDueDiligenceComponent {
	constructor(
		configQueries: ConfigQueries,
		entityQueries: EntityQueries,
		http: HttpService,
		onboardingQueries: OnboardingQueries,
		stepperQueries: StepperQueries,
		_snackBar: MatSnackBar
	) {
		super(
			configQueries,
			entityQueries,
			http,
			onboardingQueries,
			stepperQueries,
			_snackBar
		);
	}
}
